var map = {
	"../accounts/dashboard/dashboard.module": [
		"./src/app/pages/main/accounts/dashboard/dashboard.module.ts",
		"default~accounts-dashboard-dashboard-module~crm-crm-module~pages-main-tabs-tabs-module~service-dashb~4f9f4422",
		"common",
		"accounts-dashboard-dashboard-module"
	],
	"../crm/crm.module": [
		"./src/app/pages/main/crm/crm.module.ts",
		"default~accounts-dashboard-dashboard-module~crm-crm-module~pages-main-tabs-tabs-module~service-dashb~4f9f4422",
		"common",
		"crm-crm-module"
	],
	"../reports/dashboard/dashboard.module": [
		"./src/app/pages/main/reports/dashboard/dashboard.module.ts",
		"common",
		"reports-dashboard-dashboard-module"
	],
	"../service/dashboard/dashboard.module": [
		"./src/app/pages/main/service/dashboard/dashboard.module.ts",
		"default~accounts-dashboard-dashboard-module~crm-crm-module~pages-main-tabs-tabs-module~service-dashb~4f9f4422",
		"common",
		"service-dashboard-dashboard-module"
	],
	"../settings/dashboard/dashboard.module": [
		"./src/app/pages/main/settings/dashboard/dashboard.module.ts",
		"default~accounts-dashboard-dashboard-module~crm-crm-module~pages-main-tabs-tabs-module~service-dashb~4f9f4422",
		"common",
		"settings-dashboard-dashboard-module"
	],
	"../stock/dashboard/dashboard.module": [
		"./src/app/pages/main/stock/dashboard/dashboard.module.ts",
		"default~accounts-dashboard-dashboard-module~crm-crm-module~pages-main-tabs-tabs-module~service-dashb~4f9f4422",
		"default~pages-main-tabs-tabs-module~stock-dashboard-dashboard-module",
		"common",
		"stock-dashboard-dashboard-module"
	],
	"../vehicle_sales/dashboard/dashboard.module": [
		"./src/app/pages/main/vehicle_sales/dashboard/dashboard.module.ts",
		"default~accounts-dashboard-dashboard-module~crm-crm-module~pages-main-tabs-tabs-module~service-dashb~4f9f4422",
		"common",
		"vehicle_sales-dashboard-dashboard-module"
	],
	"./pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"pages-login-login-module"
	],
	"./pages/main/tabs/tabs.module": [
		"./src/app/pages/main/tabs/tabs.module.ts",
		"default~accounts-dashboard-dashboard-module~crm-crm-module~pages-main-tabs-tabs-module~service-dashb~4f9f4422",
		"default~pages-main-tabs-tabs-module~stock-dashboard-dashboard-module",
		"common",
		"pages-main-tabs-tabs-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;